export const AvailabilityStatus = Object.freeze({
  UNSET: 'unset',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  PARTIAL: 'partial',
})
